var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAlert = function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.053 21",
    fill: "none",
    stroke: "#fff"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_alert-triangle_2561317",
    transform: "translate(0.526 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M11.17,3.961,1.847,19.583A2.21,2.21,0,0,0,3.729,22.9H22.374a2.21,2.21,0,0,0,1.882-3.314L14.934,3.961a2.2,2.2,0,0,0-3.764,0Z",
    transform: "translate(-1.552 -2.897)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_49",
    "data-name": "Line 49",
    y2: 4.403,
    transform: "translate(11.5 6.75)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_50",
    "data-name": "Line 50",
    transform: "translate(11.5 15.581)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
};
export default SvgAlert;